import { GetPageResponse } from "@store/features/crm/pageV2Slice";
import { DataType } from "skedyul-db/browser";
import { Params } from "../../helpers";
import { getByPath, getErrorForRowAndPath } from "./utils";

export const createSelectCell = (
  field: {
    type: DataType;
    definition?: {
      options?: Array<{ value: string; label: string }>;
      limitChoices?: number | null;
    } | null;
    label?: string;
  },
  _params: Params,
  accessorPath: string,
  pageData?: GetPageResponse,
): {
  component: "Select";
  generateProps: (
    row: Record<string, unknown>,
    _index: number,
    originalRow?: Record<string, unknown>,
  ) => {
    id: string;
    value: string;
    originalValue: string;
    items: Array<{ value: string; label: string }>;
    fieldError: { code: string; message: string } | undefined;
    handleChange: (value: string) => void;
  };
} => {
  return {
    component: "Select" as const,
    generateProps: (
      row: Record<string, unknown>,
      _index: number,
      originalRow?: Record<string, unknown>,
    ) => {
      const currentValue = getByPath(row, accessorPath);
      const originalValue = originalRow
        ? getByPath(originalRow, accessorPath)
        : undefined;

      const result: {
        id: string;
        value: string;
        originalValue: string;
        items: Array<{ value: string; label: string }>;
        fieldError: { code: string; message: string } | undefined;
        handleChange: (value: string) => void;
      } = {
        id: accessorPath,
        value:
          typeof currentValue === "string"
            ? currentValue
            : String(currentValue ?? ""),
        originalValue:
          typeof originalValue === "string"
            ? originalValue
            : String(originalValue ?? ""),
        items:
          field.definition?.options?.map((o) => ({
            value: o.value,
            label: o.label,
          })) || [],
        fieldError: getErrorForRowAndPath(row, accessorPath, pageData || null),
        handleChange: (value: string) => {},
      };

      return result;
    },
  };
};
